export const MenuActionTypes = {
  MENU_ACTION: "MENU_ACTION",
};
